import React from "react";
import { useSelector } from "react-redux";
import PercentageDisplay from "../../../../components/percentageDisplay/percentageDisplay";
import { formatChurnRate } from "../../../../utils/formatChurnRate";
import PercentChanged from "../../../../components/percentChanged/percentChanged";
import SectionContainer from "../../../../components/sectionContainer/sectionContainer";

const AttritionRateStats = () => {
  const isUserQa = useSelector((state) => state.commonReducer.commonProps.qa);

  const { churnRate, valueChange } = useSelector((state) => state.membershipSales.statistics);

  const value = formatChurnRate(churnRate?.value);

  return (
    <SectionContainer
      title="ATTRITION RATE"
      toolTip={churnRate?.tooltip}
      toolTipId="membershipDetailsAttritionRate"
      isToolTipHtml
    >
      <PercentageDisplay
        value={value}
        disableAnimation={isUserQa}
        showDecimal
        toFixedValue={value > 0 ? 2 : undefined}
        toolTipContent={churnRate?.tooltip}
        toolTipId="membershipDetailsAttritionRate"
      />
      <PercentChanged
        changeValue={valueChange}
        toolTip="Percentage change"
        showBorder
        positiveColor="#c7343e"
        negativeColor="#21e981"
      />
    </SectionContainer>
  );
};

export default AttritionRateStats;
